import { useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import ImageWithFallback from "@/components/ui/custom/fallback-image-sv";
import { Trash } from "lucide-react";
import { Button } from "../ui/button";

const Lightbox = ({
  isOpen,
  imageIndex,
  onClose,
  images,
  showDelete,
  handleDelete,
}) => {
  if (!isOpen) return null;

  const [nextImage, setNextImage] = useState(imageIndex);

  function imgSlide(para) {
    if (nextImage === 0 && para === "pre") {
      // if its first image then set next image to last image
      setNextImage(images.length - 1);
    } else if (nextImage === images.length - 1 && para === "nxt") {
      // if its last image then set next image to first image
      setNextImage(0);
    } else {
      para === "pre"
        ? setNextImage(nextImage - 1)
        : setNextImage(nextImage + 1);
    }
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-75 ">
      {/* <div className='absolute cursor-pointer left-0 top-0 text-white' onClick={()=>imgNext()}>NextImage</div> */}
      <button
        className="absolute left-6 top-1/2 -translate-x-1/2  -translate-y-1/2 transform  cursor-pointer text-white disabled:text-white/20"
        onClick={() => imgSlide("pre")}>
        <ChevronLeftIcon className="h-10 w-10 " />
      </button>
      <button
        className="absolute right-0 top-1/2  -translate-x-1/2  -translate-y-1/2  transform cursor-pointer text-white disabled:text-white/20"
        onClick={() => imgSlide("nxt")}>
        <ChevronRightIcon className="h-10 w-10 " />
      </button>

      <div className="flex w-full max-w-3xl items-center justify-center">
        {/* <img src={images[nextImage].image} alt="Lightbox" className="rounded-lg shadow-lg" /> */}
        {images[nextImage]?.includes(".mp4") ? (
          <video
            className="rounded-lg object-contain shadow-lg"
            controls
            style={{
              maxWidth: "100%",
              height: "auto",
            }}>
            <source src={images[nextImage]} type="video/mp4" />
          </video>
        ) : (
          <ImageWithFallback
            src={images[nextImage]}
            alt="Lightbox"
            width={1000}
            height={1000}
            layout="responsive"
            className="rounded-lg shadow-lg"
          />
        )}
        <div>
          {showDelete && images[nextImage] && (
            <Button
              className={`absolute right-10 top-0 m-4 border-[1px] border-lightRed
             bg-white  text-lightRed hover:border-lightRed
              hover:bg-lightRed  hover:text-white
             `}
              onClick={() => handleDelete(images[nextImage])}>
              <Trash className=" mr-2 w-5" />
              Delete
            </Button>
          )}

          <button
            className="absolute right-0 top-2 m-4 text-gray-400 hover:text-white"
            onClick={onClose}>
            <svg
              className="h-6 w-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24">
              <path d="M12 10.586l4.95-4.95a1 1 0 0 1 1.415 1.414L13.415 12l4.95 4.95a1 1 0 0 1-1.414 1.415L12 13.415l-4.95 4.95a1 1 0 0 1-1.415-1.414L10.586 12 5.636 7.05A1 1 0 0 1 7.05 5.636L12 10.586z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Lightbox;
